import {
  Assessment as AssessmentIcon,
  Book as BookIcon,
  Close as CloseIcon,
  ContactMail as ContactMailIcon,
  Dashboard as DashboardIcon,
  Help as HelpIcon,
  Info as InfoIcon,
  School as SchoolIcon,
  Work as WorkIcon,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import img from "../../img/png3.png";
import { MdOutlineContactPage } from "react-icons/md";
import { SiGnuprivacyguard } from "react-icons/si";

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const links = [
    { name: "Dashboard", href: "/", icon: <DashboardIcon /> },
    { name: "Jobs", href: "/jobs", icon: <WorkIcon /> },
    { name: "Admitcard", href: "/admitcard", icon: <ContactMailIcon /> },
    { name: "Results", href: "/results", icon: <AssessmentIcon /> },
    { name: "Answer Key", href: "/answer-key", icon: <InfoIcon /> },
    { name: "Syllabus", href: "/syllabus", icon: <BookIcon /> },
    { name: "Admission", href: "/admission", icon: <SchoolIcon /> },
    { name: "Important", href: "/important", icon: <InfoIcon /> },
    { name: "FAQ", href: "/faq", icon: <HelpIcon /> },
    { name: "Contact Us", href: "/contact-us", icon: <MdOutlineContactPage /> },
    {name:"Register", href: "/register", icon: <SiGnuprivacyguard />}
  ];

  const handleLinkClick = (href) => {
    navigate(href);
    if (isMobile) {
      onClose();
    }
  };

  return (
    <Drawer
      variant={isMobile ? "temporary" : "permanent"}
      anchor="left"
      open={isOpen}
      onClose={onClose}
      sx={{
        width: 240,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: 240,
          boxSizing: "border-box",
          background: "#191970",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: {
            lg: "center",
            xs: "space-between",
            md: "space-between",
          },
          p: 2,
          zIndex: 1300,
        }}
      >
        <Avatar src={img} ml={2} sx={{ width: 70, height: 70 }} />
        {isMobile && (
          <IconButton onClick={onClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        )}
      </Box>
      <List>
        {links.map((link) => (
          <ListItem
            key={link.name}
            onClick={() => handleLinkClick(link.href)}
            sx={{ color: "white", cursor: "pointer" }}
          >
            <ListItemIcon sx={{ color: "white" }}>{link.icon}</ListItemIcon>
            <ListItemText primary={link.name} />
          </ListItem>
        ))}
      </List>
     
    </Drawer>
  );
};

export default Sidebar;
